import { create } from "zustand";
import { leitenRequest } from "../../leiten/controllers/leitenRequest";
import { ApiAccount } from "../../requests/getAccounts";
export const useAccountsStore = create(() => ({
    accounts: {},
}));
export const useAccounts = leitenRequest(useAccountsStore, "accounts", async (response) => response || window.__REACT_MENU__?.accounts?.results || (await ApiAccount.get())?.results);
